import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { UseMutationOptions, useMutation } from 'react-query'

interface SaveAudioParams {
  almanacFileKey: string
  selectedAudioId?: string | null
  selectedAudioTitle?: string | null
  selectedAudioDuration?: number | null
  musicStartTime: number
  removeOriginalAudio: boolean
  audioSource?: 'stock' | 'brand_kit'
  audioMediaFileKey?: string | null
}

type Data = { success: boolean; processing?: boolean }

type Options = Omit<UseMutationOptions<Data, Error, SaveAudioParams>, 'mutationKey' | 'mutationFn'>

const saveAudio = async (
  workspaceId: number,
  {
    almanacFileKey,
    selectedAudioId,
    selectedAudioTitle,
    selectedAudioDuration,
    musicStartTime,
    removeOriginalAudio,
    audioSource,
    audioMediaFileKey,
  }: SaveAudioParams,
) => {
  const res = await sendToApi(`/w/${workspaceId}/designs/${almanacFileKey}/save_audio`, {
    method: 'POST',
    body: {
      audio_id: selectedAudioId,
      audio_title: selectedAudioTitle,
      audio_duration: selectedAudioDuration,
      music_start_time: musicStartTime,
      remove_original_audio: removeOriginalAudio,
      audio_source: audioSource,
      audio_media_file_key: audioMediaFileKey,
    },
  })

  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(res.data)
  }

  return res.data
}

export const useSaveDesignAudio = (options?: Options) => {
  const workspaceId = useCurrentWorkspaceId()

  return useMutation<Data, Error, SaveAudioParams>((params) => saveAudio(workspaceId, params), options)
}
